import { useQuery } from '@tanstack/react-query'
import { listRelatedCompumaticPunches } from 'api/admin/timeClock/listCompumaticPunches'
import { timeClockKeys } from './keys'

export function useRelatedCompumaticPunchesQuery(
  punchId: number,
  options: { enabled?: boolean } = {}
) {
  return useQuery({
    queryKey: timeClockKeys.compumaticPunchRelated(punchId),
    queryFn: () => listRelatedCompumaticPunches(punchId),
    enabled: options.enabled ?? true,
  })
}
